let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a6oF6")).then(() => parcelRequire('b7y3F'));